"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create_qr_auth_session = void 0;
const api_1 = require("../../api");
function create_qr_auth_session({ authorization, webApp, expectedUid, facetecDbRef, metadata, }) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new api_1.API().apiPost({
            baseUrl: (_a = process.env.SKY_LIFESTYLE_API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: "v2/qr-auth/session",
            content: {
                webApp,
                expectedUid: expectedUid !== null && expectedUid !== void 0 ? expectedUid : undefined,
                facetecDbRef: facetecDbRef !== null && facetecDbRef !== void 0 ? facetecDbRef : undefined,
                metadata,
            },
            authorization,
            loader: false,
        });
        return response;
    });
}
exports.create_qr_auth_session = create_qr_auth_session;
